import React from 'react';
import AdminAuth from '../components/admin/AdminAuth';
import ContentEditor from '../components/admin/ContentEditor';

const ContentEditorPage = () => (
  <AdminAuth>
    <ContentEditor />
  </AdminAuth>
);

export default ContentEditorPage;
